import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed, useAttrs } from 'vue';
import dayjs, { type Dayjs } from 'dayjs';
import { DialogProgrammatic } from 'buefy';

import HolidayService from '@/service/holiday.service';

export interface Props {
  isDateTime?: boolean;
  indicators?: string;
  legendTooltipPosition?: string;
}

export interface Holiday {
  id?: string;
  name?: string;
  date?: Date;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HolidayDatepicker',
  props: {
    isDateTime: { type: Boolean, default: false },
    indicators: { default: 'bars' },
    legendTooltipPosition: { default: 'is-left' }
  },
  emits: ['input'],
  setup(__props: any, { emit: emits }) {

const props = __props as { isDateTime: boolean, indicators: string, legendTooltipPosition: string }

const attrs = useAttrs();



const holidays = ref<Holiday[]>([]);
const selectedDate = ref<Dayjs>();

onMounted(async () => {
  holidays.value = await HolidayService.list();
});

const events = computed(() => {
  return holidays.value.map(holiday => ({ date: holiday.date, type: 'is-danger' }));
});

const dateTimeDatepickerAttrs = computed(() => {
  return { ...attrs.datepicker, events: events.value, indicators: props.indicators };
});

function emitInput(date) {
  selectedDate.value = dayjs(date);
  emits('input', date);
}

function confirmIfDateMatchesKnownHolidays() {
  holidays.value.every(holiday => {
    if (selectedDate.value?.isSame(holiday.date, 'day')) {
      DialogProgrammatic.confirm({
        message: `The selected date ${selectedDate.value.format('M/D/YYYY')} is ${
          holiday.name
        }. Please confirm this selection is correct.`,
      });
      return false;
    }
    return true;
  });
}

return { __sfc: true,attrs, emits, props, holidays, selectedDate, events, dateTimeDatepickerAttrs, emitInput, confirmIfDateMatchesKnownHolidays }
}

})